import { ColDef } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const eipColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("IP", "ip"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("eip"),

  resourceAccountColumnDef,

  resourceCreatedByColumnDef,

  regionColumnDef,

  tagsColumnDef,

  smartTagsColumnDef,

  taskColumnDef,

  jiraIssuesColumnDef,
];
